import React, { useState, useRef, useEffect } from "react";
import ArrowTop from "../../Common/svg/arrowtop";
import WhiteArrowSvg from "../../Common/svg/whiteArrow";
import { useMutation } from "react-query";
import { updateStore } from "../../../MyApi/stores";
import Swal from "sweetalert2";
import SkeletonWrapper from "../../UI/skeletonWrapper";

const AttachmentInfo = ({
  logo: initialLogo,
  cover_image: initialCover,
  storeId,
  refetch,
  isLoading
}) => {
  const [logo, setLogo] = useState(initialLogo);
  const [coverImage, setCoverImage] = useState(initialCover);
  const [logoFile, setLogoFile] = useState(null);
  const [coverFile, setCoverFile] = useState(null);
  const mutation = useMutation({
    mutationKey: ["updateStore"],
    mutationFn: (formData) => updateStore(formData, storeId),
    onSuccess: () => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        text: "تم تحديث صور المتجر بنجاح",
      });
      refetch();
    },
    onError: (error) => {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: "حدث خطأ أثناء تحديث الصور",
      });
      console.error("Update error:", error);
    },
  });
  const logoInputRef = useRef(null);
  const coverInputRef = useRef(null);

  useEffect(() => {
    setCoverImage(initialCover);
    setLogo(initialLogo);
  }, [initialLogo, initialCover]);

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      if (type === "logo") {
        setLogo(url);
        setLogoFile(file);
      }
      if (type === "cover") {
        setCoverImage(url);
        setCoverFile(file);
      }
    }
  };

  const handleSave = () => {
    const formData = new FormData();
    formData.append("_method", "PUT");
    if (logoFile) {
      formData.append("store[logo]", logoFile);
    }
    if (coverFile) {
      formData.append("store[cover_image]", coverFile);
    }
    if (logoFile || coverFile) {
      mutation.mutate(formData);
    } else {
      Swal.fire({
        icon: "warning",
        title: "لا توجد تغييرات",
        text: "يرجى اختيار صور جديدة قبل الحفظ",
      });
    }
  };

  const handleReset = () => {
    setLogo(initialLogo);
    setCoverImage(initialCover);
    setLogoFile(null);
    setCoverFile(null);
  };

  return (
    <div className="row">
      <h5 className="font16">المرفقات</h5>

      {/* Logo */}
      <div className="col-md-6">
        <h5 className="font14 mb-2">صورة اللوجو</h5>
             <SkeletonWrapper isLoading={isLoading}>

        
        <div
          className="flex-grow-1 border rounded-4 text-center upload-box position-relative"
          style={{ cursor: "pointer", minWidth: "250px" }}
          onClick={() => logoInputRef.current && logoInputRef.current.click()}
        >
          {logo ? (
            <div className="relative w-100 ratio ratio-1x1">
              <img
                src={logo}
                className=" w-100 h-100 object-fit-contain  rounded-4"
                alt="Logo"
              />
              <div className="overLay w-100 h-100 rounded-4">
                <div>
                  <WhiteArrowSvg />
                  <h5 className="text-white"> تغيير صورة اللوجو</h5>
                </div>
              </div>
            </div>
          ) : (
            <>
              <ArrowTop />
              <h6 className="fw-bold mb-1">تحميل صورة اللوجو</h6>
              <p className="text-muted small mb-0">
                (JPG / PNG) ارفع صورة بجودة عالية
              </p>
              <p className="text-muted small mb-0">الأبعاد 1:1</p>
            </>
          )}

          <input
            ref={logoInputRef}
            type="file"
            accept="image/png, image/jpeg"
            hidden
            onChange={(e) => handleFileChange(e, "logo")}
          />
        </div>
             </SkeletonWrapper>
      </div>   

      {/* Cover Image */}   
      <div className="col-md-6">
        <h5 className="font14 mb-2">صورة الغلاف</h5>
        <SkeletonWrapper isLoading={isLoading}>

        <div
          className="flex-grow-1 border rounded-4 text-center upload-box position-relative"
          style={{ cursor: "pointer", minWidth: "250px" }}
          onClick={() => coverInputRef.current.click()}
        >
          {coverImage ? (
            <div className="relative w-100 ratio ratio-1x1">
              <img
                src={coverImage}
                className="w-100 h-100 object-fit-contain
                rounded-4"
                alt="Logo"
              />
              <div className="overLay w-100 h-100 rounded-4">
                <div>
                  <WhiteArrowSvg />
                  <h5 className="text-white"> تغيير صورة الغلاف</h5>
                </div>
              </div>
              <input
                ref={coverInputRef}
                type="file"
                accept="image/png, image/jpeg"
                hidden
                onChange={(e) => handleFileChange(e, "cover")}
                />
            </div>
          ) : (
            <>
              <ArrowTop /> <h6 className="fw-bold mb-1">تغيير صورة الغلاف</h6>
              <p className="text-muted small mb-0">
                (JPG / PNG) ارفع صورة بجودة عالية
              </p>
              <p className="text-muted small mb-0">الأبعاد 1:1</p>
              <input
                ref={coverInputRef}
                type="file"
                name="logo"
                accept="image/png, image/jpeg"
                hidden
                onChange={(e) => handleFileChange(e, "cover")}
                />
            </>
          )}
        </div> </SkeletonWrapper>
      </div>
               

      <div className="d-flex gap-2 align-items-center mt-4">
        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={mutation.isLoading}
        >
          {mutation.isLoading ? "جاري الحفظ..." : "حفظ التغييرات"}
        </button>
        <button
          className="btn btn-white"
          onClick={handleReset}
          disabled={mutation.isLoading}
        >
          إعادة ضبط
        </button>
      </div>
    </div>
  );
};

export default AttachmentInfo;
